import StyleSheetRW from "core/StyleSheetRW";
import Menu from "../Menu";
import { useEffect, useState } from "react";
import { onValue, ref } from "firebase/database";
import { db } from "@react-native-firebase/database";
import { View, Text, TouchableOpacity } from "react-native";
import DropDownField from "src/components/DropDownField";
import AddNewQuestionnaire from "src/components/AddNewQuestionnaire";
import Loader from "src/components/Loader";
import { BsPenFill } from "react-icons/bs";

const AdminQuestionnaireScreen = () => {
  const [addQuestionnaire, setAddQuestionnaire] = useState(false);
  const [roles, setRoles] = useState([]);
  const [changeRole, setChangeRole] = useState("");
  const [questionnaireData, setQuestionnaireData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [editRole, setEditRole] = useState(false)
  const [editRoleName, setEditRoleName] = useState("")
  useEffect(() => {
    setShowLoader(true);
    const dbRef = ref(db, "userRoles");
    const unsubscribe = onValue(dbRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const rolesList = Object.keys(data).map((key) => data[key]);
        setRoles(rolesList);
        setShowLoader(false);
      } else {
        console.log("No data available");
        setShowLoader(false);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    setShowLoader(true);

    const dbRef = ref(db, `questionnaire`);
    onValue(dbRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const records = [];
        Object.keys(data).forEach((role) => {
          const title = data[role].title;
          records.push({ role, title });
        });
        setQuestionnaireData(records);
        setShowLoader(false);

      }
    });
  }, []);


  const handleRoleChange = (value) => {
    setShowLoader(true);
    const dbRef = ref(db, `questionnaire/${value}`)
    onValue(dbRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const records = [];
        if (value) {
          records.push({ title: data.title, role: value })


        }
        console.log(records)

        setQuestionnaireData(records);
      } else {
        setQuestionnaireData([]);
      }
      setShowLoader(false);
    });
  };



  return (
    <div style={styles.mainContainer}>
      <Menu />
      {showLoader && <Loader />}
      <div style={styles.container}>
        <div >
          <h1 style={styles.heading}>Questionnaire</h1>
        </div>
        {!addQuestionnaire &&
          <TouchableOpacity
            style={styles.addButton}
            onPress={() => {
              setAddQuestionnaire(true);
              setEditRole(true);
              setEditRoleName("");

            }}
          >
            <Text style={styles.addCandidateButtonText}>Add New</Text>
          </TouchableOpacity>}
        {addQuestionnaire && (
          <AddNewQuestionnaire onPress={() => setAddQuestionnaire(false)} edit={editRole} role={editRoleName} />
        )}
        {!addQuestionnaire && (
          <>
            <View style={styles.inputContainer}>
              <Text style={{ ...styles.label, marginTop: 5 }}>
                Please select a UserRole
              </Text>
              <View style={{ display: "flex", flexDirection: "row" }}>
                <DropDownField
                  value={changeRole}
                  placeholder="Please Select a Role"
                  placeholderTextColor={"rgb(109,126,124)"}
                  bodyStyle={{ marginHorizontal: 0 }}
                  options={roles}
                  onChangeText={setChangeRole}
                  label="Role"
                />
                <TouchableOpacity
                  style={{ ...styles.addButton, marginLeft: 20 }}
                  onPress={() => handleRoleChange(changeRole)}
                >
                  <Text style={styles.addCandidateButtonText}>Apply</Text>
                </TouchableOpacity>
              </View>
            </View>
            <div style={styles.tableScroll}>
              <table
                style={styles.tableContainer}
              >
                <thead style={{ fontSize: 14 }}>
                  <tr style={styles.tableHeadRow}>
                    <th style={styles.tableHead}>
                      Role
                    </th>
                    
                    <th style={styles.tableHead}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {questionnaireData.map((record, index) => (
                    <tr key={index}>
                      <td style={styles.tableData}>
                        {record.role}
                      </td>
                     
                      <td style={styles.tableDataLastColumne}>

                      <TouchableOpacity
                          onPress={() => {
                            setEditRole(false);
                            setEditRoleName(record.role);
                            setAddQuestionnaire(true)
                          }}
                        >
                          <BsPenFill style={styles.editPencil} />


                        </TouchableOpacity>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const styles = StyleSheetRW.create(() => ({
  mainContainer:{ display: "flex", flexDirection: "row", height: "100%" },
  container:{ flex: 1, padding: 20, overflow: "scroll" },
  heading: { fontWeight: "bold", fontSize: 32, color: "#2F4858", marginTop: 0 },
  tableContainer:{
    borderCollapse: "collapse",
    backgroundColor: "#FFFFFF66",
    width: "100%",
    overflow: "hidden",
  },
  tableData:{ borderRight: "1px solid black", padding: "15px" },
  tableDataLastColumne:{ padding: "15px", paddingLeft: "25px" },
  tableHeadRow:{ backgroundColor: "#2F4858", color: "#FFFFFF" },
  tableScroll:{ overflow: "scroll" },
  tableHead:{ padding: "15px" },
  editPencil:{ width: 20, height: 20, alignSelf: 'center', color: "#2F4858", },
  addButton: {
    width: 147,
    backgroundColor: "#2F4858",
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 100,
    color: "white",
    fontWeight: "300",
    textAlign: "center",
    borderWidth: 0,
    alignSelf: "center",
    height: "38px",
    cursor: "pointer",
  },
  addCandidateButtonText: {
    color: "white",
    fontWeight: "400",
    textAlign: "center",
  },
  inputContainer: {
    maxWidth: "400px",
    marginLeft: 5,
    marginVertical: 20,
  },
  label: {
    fontFamily: "Outfit",
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 17.64,
    textAlign: "left",
    marginBottom: 5,
    color: "#333333",
  },
  editButton: {
    backgroundColor: "#2F4858",
    color: "white",
    padding: "5px 10px",
    borderRadius: 20,
    cursor: "pointer",
    fontSize: 16,
    width: "50px",
    flex: 1
  },
}));

export default AdminQuestionnaireScreen;
